// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1juIa","tabsBox":"styles_tabsBox__26kLJ","createButton":"styles_createButton__2UjOz"};